import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { SeoTags } from "../../components";
import { AboutComponent } from "../../components/info/AboutComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const AboutPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return (
    <>
      <SeoTags pageKey="aboutPage" />
      <AboutComponent />
    </>
  );
};

export default withTranslation()(AboutPage);
